<div class="dialog-content-wrapper fav-icon-dialog-wrapper">
    <mat-toolbar class="mat-primary m-0">
      <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center" class="justify-between">
        <span class="title dialog-title text-xl text-black m-0">Accept Terms and Condition</span>
        <button mat-icon-button (click)="matDialogRef.close({ action: 'cancel', accepted: isTermsAndConditionAccepted })" aria-label="Close dialog">
          <mat-icon>close</mat-icon>
        </button> 
      </mat-toolbar-row>
    </mat-toolbar>
  
    <div mat-dialog-content class="mx-0">
      <div class="py-2 m-0 scroll-fix-height">
        <div class="flex items-start">
          <mat-checkbox class="remember-me me-2"color="primary" aria-label="Accept" (change)="onChangeAccept($event)"></mat-checkbox>
          <p class="my-0">
            I acknowledge that I have read and agree to the 
            <a routerLink="/auth/terms" target="_blank">Terms of Use</a> 
            and 
            <a routerLink="/auth/privacy" target="_blank">Privacy Policy</a>. 
            I further acknowledge and agree to the Terms and Conditions.
          </p>
        </div>
      </div>
    </div>
  
    <mat-divider></mat-divider>
  
    <div mat-dialog-actions class="m-0 p-3 flex justify-end items-center">
      <button
        mat-raised-button
        color="primary"
        class="me-2"
        [disabled]="!isTermsAndConditionAccepted"
        (click)="matDialogRef.close({ action: 'submit', accepted: isTermsAndConditionAccepted })"
      >
        Submit
      </button>
      <button
        mat-button
        color="warn"
        class="mx-0"
        (click)="matDialogRef.close({ action: 'cancel', accepted: isTermsAndConditionAccepted })"
      >
        Cancel
      </button>
    </div>
  </div>
  